// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__1+tDe"};